/*基础页面路由*/
let baserouter = [
  /*页面*/
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: () =>
      import('@/views/index')
  },
  /*医院通知*/
  {
    path: '/notice',
    name: 'notice',
    meta: {
      title: '医院通知'
    },
    component: () =>
      import('@/views/notice')
  },
  /*医院通知详情*/
  {
    path: '/noticedetail',
    name: 'noticedetail',
    meta: {
      title: '医院公告详情'
    },
    component: () =>
      import('@/views/noticedetail')
  },
  /*新闻中心*/
  {
    path: '/news',
    name: 'news',
    meta: {
      title: '新闻中心'
    },
    component: () =>
      import('@/views/news')
  },
  /*新闻中心详情*/
  {
    path: '/newsdetail',
    name: 'newsdetail',
    meta: {
      title: '医院公告详情'
    },
    component: () =>
      import('@/views/newsdetail')
  },
  /*信息公告*/
  {
    path: '/message',
    name: 'message',
    meta: {
      title: '信息公告'
    },
    component: () =>
      import('@/views/message')
  },
  /*信息公告详情*/
  {
    path: '/messagedetail',
    name: 'messagedetail',
    meta: {
      title: '信息公告详情'
    },
    component: () =>
      import('@/views/messagedetail')
  },
  /*科室介绍*/
  {
    path: '/department',
    name: 'department',
    meta: {
      title: '科室介绍'
    },
    component: () =>
      import('@/views/department')
  },
  /*科室介绍，详情*/
  {
    path: '/departmentdetail',
    name: 'departmentdetail',
    meta: {
      title: '科室介绍详情'
    },
    component: () =>
      import('@/views/departmentdetail')
  },
  /*健康资讯*/
  {
    path: '/information',
    name: 'information',
    meta: {
      title: '健康资讯'
    },
    component: () =>
      import('@/views/information')
  },
  /*健康资讯，详情*/
  {
    path: '/informationdetail',
    name: 'informationdetail',
    meta: {
      title: '健康资讯详情'
    },
    component: () =>
      import('@/views/informationdetail')
  },
  /*联系我们*/
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: '联系我们'
    },
    component: () =>
      import('@/views/contact')
  },
  {
    path: '/',
    redirect: {
      name: 'index'
    },
    meta: {
      title: '首页'
    },
    component: () =>
      import('@/views/index'),
  },
  /*{
    path: '/',
    redirect: {
      name: 'Home'
    },
    meta: {
      title: '母版'
    },
    component: () =>
      import('@/views/layout/main'),
    children: [
      /!*后台首页*!/
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () =>
          import('@/views/home/home')
      },
    ]
  },*/
  /*测试页面*/
  {
    path: '/test',
    name: 'Test',
    meta: {
      title: '测试'
    },
    component: () =>
      import('@/views/help/test')
  },
  /*字体图标查找页面*/
  {
    path: '/fonticon',
    name: 'Fonticon',
    meta: {
      title: '字体图标'
    },
    component: () =>
      import('@/views/help/fonticon')
  }
];

/*错误页面路由*/
export const errpage = [{
  path: '*',
  name: 'Page404',
  meta: {
    title: '错误页面'
  },
  component: () =>
    import('@/views/error-page/404')
}]

export default baserouter;



// WEBPACK FOOTER //
// ./src/router/baseRouter.js